var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import { Button, RangeSlider, TextInput } from '@leapfinance/geebee-component-library';
import { Divider, Popover } from '@mui/material';
import classNames from 'classnames';
import { isFalsy } from '../../../../utils/common';
import useCFFilters from './useCFFilters';
var DurationCFFilter = function (props) {
    var courseDurationValues = useCFFilters({}).courseDurationValues;
    var _a = __read(useState(courseDurationValues), 2), value = _a[0], setValue = _a[1];
    var _b = __read(React.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = __read(useState(null), 2), prevValues = _c[0], setPrevValues = _c[1];
    var inputRef = useRef();
    var open = Boolean(anchorEl);
    var id = open ? 'university-duration-filter-popover' : undefined;
    useEffect(function () {
        setValue(courseDurationValues);
    }, [courseDurationValues]);
    useEffect(function () {
        if (open) {
            setPrevValues(value);
        }
    }, [open]);
    var handleClose = function (isApplied) {
        setAnchorEl(null);
        if (!isApplied) {
            setValue(prevValues);
        }
        setTimeout(function () { var _a; return (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.blur(); }, 0);
    };
    var handleApply = function () {
        props === null || props === void 0 ? void 0 : props.handleFilterApply({ name: props === null || props === void 0 ? void 0 : props.name, value: value !== null && value !== void 0 ? value : courseDurationValues });
        handleClose(true);
    };
    return (React.createElement("div", { "data-hasValue": true },
        React.createElement("div", { onClick: function (event) {
                setAnchorEl(event.currentTarget);
            } },
            React.createElement(TextInput, { label: "Course Duration", keepDefaultLabelBehaviour: true, className: classNames('lfc-w-[190px]  lfc-transition-all '), InputLabelProps: { shrink: open || !isFalsy(value) }, placeholder: "Select Course Duration", InputProps: {
                    readOnly: true,
                    value: open ? '' : "".concat(value === null || value === void 0 ? void 0 : value[0], " months - ").concat(value === null || value === void 0 ? void 0 : value[1], " months"),
                    sx: function (theme) {
                        var _a, _b, _c, _d, _e;
                        return !open
                            ? {
                                '&.MuiOutlinedInput-root': {
                                    backgroundColor: (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a['200'],
                                    fieldSet: {
                                        borderColor: (_b = theme.palette.primary) === null || _b === void 0 ? void 0 : _b['500']
                                    },
                                    ':hover': {
                                        backgroundColor: (_c = theme.palette.primary) === null || _c === void 0 ? void 0 : _c['200']
                                        // fieldSet: {
                                        //   borderColor: theme.palette.primary?.['500']
                                        // }
                                    },
                                    '.MuiInputAdornment-positionStart': {
                                        '.MuiTypography-root': {
                                            color: (_d = theme.palette.primary) === null || _d === void 0 ? void 0 : _d['500']
                                        }
                                    },
                                    input: {
                                        textOverflow: 'ellipsis',
                                        color: (_e = theme.palette.primary) === null || _e === void 0 ? void 0 : _e['500']
                                    }
                                }
                            }
                            : {
                                '&.MuiOutlinedInput-root': {
                                    backgroundColor: 'white'
                                }
                            };
                    }
                }, size: "small", inputRef: inputRef })),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: function () {
                handleClose();
            }, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            }, transformOrigin: { vertical: 0, horizontal: 0 }, slotProps: { paper: { sx: { overflow: 'visible' }, elevation: 0 } }, className: "lfc-mt-1 " },
            React.createElement("div", { className: "lfc-w-[350px]  lfc-gap-3 lfc-rounded-md  lfc-border lfc-shadow-lg" },
                React.createElement("div", { className: "lfc-flex  lfc-flex-col" },
                    React.createElement("div", { className: "lfc-p-4" },
                        React.createElement(RangeSlider, { value: value !== null && value !== void 0 ? value : courseDurationValues, min: 0, max: 60, displayInput: true, onChange: function (_, newValue) {
                                if (Array.isArray(newValue)) {
                                    setValue(newValue);
                                }
                            }, minLabel: "Month(s)", maxLabel: "Month(s)" })),
                    React.createElement(Divider, { className: "py-2" }),
                    React.createElement("div", { className: "lfc-p-2 lfc-self-end " },
                        React.createElement(Button, { className: "lfc-self-end", onClick: function (event) {
                                event.stopPropagation();
                                handleApply();
                            } }, "Apply")))))));
};
export default DurationCFFilter;
//# sourceMappingURL=DurationCFFilter.js.map